import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_SLOT } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Slot',
        name: 'Slot',
        icon: 'fas fa-dice',
        route: { name: ROUTE_NAME_SLOT }
    }
]);

export default registerRouteForModule(router);
